import React, { useCallback } from "react";
import "./index.less";
import { useHistory } from "react-router-dom";
import { message as toast } from "antd";
import meetinglive_png from "@/assets/img/meetinglive.png";
import meeting_png from "@/assets/img/meeting/icon-jrtc-meeting.png";
import { joinLive, openRecord } from "@/baseComponents/Meeting/utils";
import { getMinutesPermission } from "@/api/meetingRecord";

/*
  会议主题：meetingTopic
  会议号： meetingNumber
  会议密码： meetingPassword
  直播间号： liveCode
  直播间密码: livePassword
  直播间观看地址: liveUrl
  直播间主题: conferenceTitle
  会议开始时间：meetingStartTime
  分享人名字： sharerName
*/
function MeetingLiveCard({ message }: { message: any }) {
  const meetinglive_pull = message.data[0]?.meetinglive_pull || {};
  const {
    conferenceTitle,
    sharerName,
    meetingStartTime,
    liveCode = "",
    livePassword,
    avsdk
  } = meetinglive_pull;
  const history = useHistory();
  // 进入直播间
  async function handleJoinLive() {
    joinLive(
      avsdk,
      {
        liveCode: liveCode,
        livePassword: livePassword,
        name: sharerName
      },
      history
    ).catch((e) => {
      toast.error(e.message || e || "未知错误");
    });
  }
  return (
    <div className="card-live">
      <div className="card-live-header">智能会议</div>
      {/* 内容 */}
      <div className="card-live-main" onClick={handleJoinLive}>
        <div className="card-live-main-left">
          {conferenceTitle && <p className="card-live-main-left_title">{conferenceTitle}</p>}
          {sharerName && meetingStartTime && (
            <p className="card-live-main-left_desc">
              <span style={{ paddingRight: 3 }}>{sharerName}</span>
              {meetingStartTime}
            </p>
          )}
        </div>
        <div className="card-live-main-right">
          <img src={meetinglive_png} className="img" />
        </div>
      </div>
      {/* 底部 */}
      <div className="card-live-footer">
        <div className="footer_btn" onClick={handleJoinLive}>
          进入直播间
        </div>
      </div>
    </div>
  );
}

function MeetingNoteCard({ message }: { message: any }) {
  const note_share = message.data[0]?.noteShare || {};
  const history = useHistory();
  const { topic, noteId } = note_share;
  const handleOpenRecord = useCallback(async () => {
    const [res, err] = await getMinutesPermission({
      bizId: noteId
    });
    if (err) {
      toast.error(err);
      return;
    }
    openRecord({
      meetingId: noteId,
      history,
      type: res.type
    });
  }, [noteId, history]);
  return (
    <div className="card-live">
      <div className="card-live-header">智能会议-智能慧纪</div>
      <div className="card-live-main" onClick={handleOpenRecord}>
        <div className="card-live-main-left">
          {topic && <p className="card-live-main-left_title">{topic}</p>}
          <p className="card-live-main-left_desc">请点击卡片查看内容详情</p>
        </div>
        <div className="card-live-main-right">
          <img src={meeting_png} className="img" />
        </div>
      </div>
    </div>
  );
}

function MeetingCard({ message }: { message: any }) {
  const { template } = message;
  if (template?.nativeId === "note_share") {
    return <MeetingNoteCard message={message} />;
  } else if (template?.nativeId === "meetinglive_pull") {
    return <MeetingLiveCard message={message} />;
  }
  return null;
}

export default MeetingCard;
